<template>
  <v-layout row justify-center>
    <v-dialog v-model="deliveryInvoiceModal" persistent max-width="500px">
      <v-card>
        <form @submit.prevent="submitForm()">
          <v-card-title>
            <div class="headline">{{ $t('delivery.deliveryInvoiceTitle') }}</div>
          </v-card-title>
          <v-card-text class="pt-0 px-4">
            <div class="row">
              <div class="col-12">
                <h5>{{ $t('columns.customer') }}: {{ formData.customer_name }}</h5>
              </div>
              <div class="col-12">
                <h5>{{ $t('columns.phoneNumber') }}: {{ formData.phone_number }}</h5>
              </div>

              <div v-if="formData.orders && formData.orders.length > 0" class="col-12">
                <h5>{{ $t('sidebar.orders') }}</h5>
              </div>
              <div v-if="formData.orders && formData.orders.length > 0" class="col-12">
                <ol>
                  <li v-for="(order, index) in formData.orders" :key="index">
                    <h6 style="display: inline-block">#{{ order.the_order_id }}</h6>

                    <i
                      class="fa fa-remove ml-4"
                      style="font-size: 16px; color: red; cursor: pointer"
                      @click="removeOrder(index)"
                    ></i>
                  </li>
                </ol>
              </div>

              <!-- <div class="col-12">
                <branch-select v-model="formData.branch_id_fk" />
              </div> -->

              <div class="col-12">
                <v-text-field
                  :label="$t('columns.total')"
                  readonly
                  v-model="formData.customer_credit"
                  :error-messages="errors.collect('Total')"
                  data-vv-name="Total"
                />
              </div>

              <div class="col-12">
                <v-text-field
                  :label="$t('delivery.payOnDeliveryIqdLabel')"
                  v-model.number="formData.pay_on_delivery_iqd"
                  :error-messages="errors.collect('Pay on delivery (IQD)')"
                  v-validate="'required|numeric'"
                  data-vv-name="Pay on delivery (IQD)"
                />
              </div>

              <!-- <div class="col-12">
                <v-text-field label="Note" v-model="formData.note" />
              </div> -->
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="$emit('close')" style="height: auto" outline>{{ $t('common.cancel') }}</v-btn>
            <v-btn type="submit" style="height: auto" outline color="primary">{{ $t('common.save') }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['deliveryInvoiceModal', 'formData'],

  data() {
    return {}
  },

  methods: {
    removeOrder(index) {
      this.formData.orders.splice(index, 1)
      this.formData.orders_id.splice(index, 1)
    },

    submitForm() {
      if (this.formData.orders.length === 0) {
        swal(this.$t('common.warning'), this.$t('orders.pleaseAtLeastSelectOneOrder'), 'error')
        return
      }

      this.$validator.validateAll().then((res) => {
        if (res) {
          let token = localStorage.getItem('access_token')

          axios
            .post('api/delivery_invoice', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(res => {
              swal({
                title: this.$t('common.done'),
                text: this.$t('invoice.invoiceGeneratedSuccessfully'),
                icon: 'success',
                timer: 1000,
                buttons: false
              })
              this.$emit('invoice-created', res.data)
              this.$emit('close')
            })
            .catch((err) => {
              swal(this.$t('common.warning'), err.response.data.message, 'error')
            })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  overflow-y: auto !important;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/deliveryInvoice/AddDeliveryInvoice.vue